import { CountryConfig } from "../../shared/types";
import { cnyTypeOfpaymentMethod, cnyPaymentPurpose } from "../../../const";
import { chinaFormRegistry } from "./formRegistry";
import { ReactComponent as ChinaFlag } from "../../assets/china-flag.svg";

export const chinaConfig: CountryConfig = {
  code: "CNY",
  name: "China",
  dataSliceKey: "cn",
  flag: ChinaFlag,
  currencyCode: "CNY",
  formRegistry: chinaFormRegistry,
  paymentMethods: cnyTypeOfpaymentMethod,
  paymentPurposes: cnyPaymentPurpose,
  steps: [
    {
      id: "amount",
      type: "amount",
      title: "Amount",
      stepTitle: "How much are you sending?",
    },
    {
      id: "sender",
      type: "sender",
      title: "Sender",
      stepTitle: "Sender details",
    },
    {
      id: "beneficiary",
      type: "beneficiary",
      title: "Beneficiary",
      stepTitle: "Beneficiary details",
    },
    {
      id: "review",
      type: "review",
      title: "Review",
      stepTitle: "Review the details of your transaction",
    },
  ],
};
